var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapViews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.378 14.063c.986-1.163 3.56-4.367 3.56-6.126a3.937 3.937 0 10-7.876 0c0 1.759 2.574 4.963 3.56 6.126.2.236.557.236.756 0zM12 9.25a1.312 1.312 0 110-2.625 1.312 1.312 0 010 2.625zM16 20l4.371-1.748c.347-.14.629-.555.629-.929V9.501a.5.5 0 00-.686-.465L16 11v9zm-12.314-.036L8 18v-7.284a9.463 9.463 0 01-.664-1.45l-3.707 1.482c-.347.14-.629.555-.629.929v7.822a.5.5 0 00.686.465zM15 20v-7.688a32.992 32.992 0 01-1.86 2.398 1.494 1.494 0 01-2.28 0A33.01 33.01 0 019 12.312V18l6 2z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
export default __webpack_public_path__ + "static/media/4e7f9e9bbca9236d4a89f244863ee182-MapViews.svg";
export { SvgMapViews as ReactComponent };